import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { useClickGrouping } from 'components/grouping/views'
import { CommonSeriesSettings, Series, SeriesTemplate } from 'devextreme-react/chart'

export const OneClickDownloadChart: React.FunctionComponent = ({ }) => {
    const { toolbar, parameters } = useClickGrouping()
    return (
        <BPMChart title='One Click Downloads' subTitle='By Page' type='bar'
            toolBarItems={() => toolbar}
            additionalParams={{ ...parameters, entity_name: 'one_click_download' }}
            onRequestLoad={(options, signal) => BPMAnalyticsAPI.getv2<any>(`clicks/page`, options, signal)}
        >
            {!parameters.groupBy && <Series name='Click' />}

            {parameters.groupBy && <SeriesTemplate
                nameField={parameters.groupBy}
            />}

            <CommonSeriesSettings
                type={'bar'}
                valueField="count"
                argumentField="name">

            </CommonSeriesSettings>
        </BPMChart >
    )
}


// WEBPACK FOOTER //
// ./src/pages/Product/Pages/charts/OneClickDownloadChart.tsx